export class ProjectApi {
    constructor(settings) {
        this.url = settings.url;
    }
    /**
     * Gets all the organization the user is part of.
     * @param options The options.
     * @returns The organizations.
     */
    async getUserOrganizations(options) {
        const url = `${this.url}organization`;
        const response = await fetch(url, {
            headers: {
                Authorization: "Bearer " + options.accessToken,
            },
        });
        const json = await response.json();
        return json.organizations;
    }
    /**
     * Create a new project.
     * @param options The options.
     * @returns The project details.
     */
    async createProject(options) {
        const url = `${this.url}project`;
        const body = JSON.stringify({
            organizationId: options.organizationId,
            name: options.name,
            area: options.area,
            scenarios: options.scenarios
        });
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.json();
    }
    /**
     * Creates a reroute.
     * @param options The options.
     * @returns The reroute details.
     */
    async createReroute(options) {
        const url = `${this.url}shared/reroute`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.text();
    }
    /**
     * Creates a new matrix.
     * @param options The options.
     * @returns The new matrix.
     */
    async createMatrix(options) {
        const url = `${this.url}data/od/`;
        const body = JSON.stringify(options.matrix);
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        const json = await response.json();
        if (typeof json.movements !== "undefined" && json.movements != null) {
            json.movements.sort((a, b) => {
                if (a.fromIdx == b.fromIdx)
                    return a.toIdx - b.toIdx;
                return a.fromIdx - b.fromIdx;
            });
        }
        return json;
    }
    /**
     * Creates a new matrix layer.
     * @param options The options.
     * @returns The id of the new layer.
     */
    async createMatrixLayer(options) {
        const url = `${this.url}layers/trips/${options.tripsLayerId}/matrix`;
        const body = JSON.stringify(options.data);
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        return await response.text();
    }
    /**
     * Creates a new trips layer.
     * @param options The options.
     * @returns The trips layer data.
     */
    async createTripsLayer(options) {
        const url = `${this.url}layers/trips/`;
        const body = JSON.stringify(options.tripsLayer);
        const response = await fetch(url, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + options.accessToken,
                "Content-Type": "application/json"
            },
            body: body
        });
        const json = await response.json();
        json.matrices.forEach(x => {
            var _a, _b;
            if (typeof ((_a = x.matrix) === null || _a === void 0 ? void 0 : _a.movements) === "undefined" || ((_b = x.matrix) === null || _b === void 0 ? void 0 : _b.movements) == null)
                return;
            x.matrix.movements.sort((a, b) => {
                if (a.fromIdx == b.fromIdx)
                    return a.toIdx - b.toIdx;
                return a.fromIdx - b.fromIdx;
            });
        });
        return json;
    }
}
